document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.trs-swiper', {
      loop: true,
      spaceBetween: 24,
      slidesPerView: 1,
      pagination: {
        el: '.trs-swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });